// Reads the API's BaseModel envelope ({ success, message, data }), tolerating either casing.
// Anything else (a network failure, an unparseable error body) is a failure, never a silent
// success, and its technical message is not shown to the user.
export const readApiOutcome = (response) => {
  const success = response?.success ?? response?.Success;
  if (typeof success !== 'boolean') return { succeeded: false, message: '' };
  return { succeeded: success, message: response.message ?? response.Message ?? '' };
};
